import { initiateTransfer as initiateTransferRemote } from '../api/initiateTransferApi'
import {
  TransferInitiationResultWebDto,
  TransferInitiationWebDto,
} from '../api/types'
import { AxiosResponse } from 'axios'
import { ApexApiError } from 'apex-ui-services'
import { HttpResponseStatusCodes } from '../constants'
import {
  getTransferRequestValidationFailed,
  TEMPORARILY_UNAVAILABLE,
  TRANSFER_REQUEST_FAILED_MISCELLANEOUSLY,
  TRANSFER_SUCCESS,
} from './constants'
import { isEmpty, uniq } from 'lodash'
import { ToastMessage } from '../types'

export const initiateTransfer = (
  submission: TransferInitiationWebDto,
  onSuccess: (success: ToastMessage) => void,
  onError: (error: string) => void
) => {
  initiateTransferRemote(submission)
    .then((response: AxiosResponse) => {
      const result: TransferInitiationResultWebDto = response.data
      if (isEmpty(result.errors)) {
        onSuccess(TRANSFER_SUCCESS)
      } else {
        const validationMessage = uniq(
          result.errors?.map(error => error.message)
        ).join('. ')
        const error = validationMessage
          ? getTransferRequestValidationFailed(`${validationMessage}.`).replace(
              /\.\./g,
              '.'
            )
          : TRANSFER_REQUEST_FAILED_MISCELLANEOUSLY
        onError(error)
      }
    })
    .catch((error: ApexApiError) => {
      const httpResponseStatus = error.response?.status
      let errorMessage
      if (
        httpResponseStatus &&
        httpResponseStatus >= HttpResponseStatusCodes.InternalServerError
      ) {
        errorMessage = TEMPORARILY_UNAVAILABLE
      } else if (httpResponseStatus === HttpResponseStatusCodes.NotFound) {
        errorMessage = getTransferRequestValidationFailed(
          'Account does not exist.'
        )
      } else {
        errorMessage = TRANSFER_REQUEST_FAILED_MISCELLANEOUSLY
      }
      onError(errorMessage)
    })
}
